<template>
  <v-dialog v-model="isShow" max-width="500" persistent>
    <PreLoader v-if="isLoading" />
    <v-card v-else class="auth-card pa-4">
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <LogoImg :width="200" />
          </div>
        </v-col>
        <v-col cols="12" class="py-0">
          <h5 class="text-center text-h5 font-weight-semibold mb-0">
            Зарегистрироваться! 👋🏻
          </h5>
        </v-col>
        <v-col cols="12" class="pb-4">
          <p class="mb-0 text-center">
            Для получение кода сначала заполните данные
          </p>
        </v-col>
      </v-row>
      <v-card-text>
        <v-form @submit.prevent="routeMain">
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                v-model="userData.last_name"
                label="Фамилия"
                type="email"
                outlined
                :rules="[required]" />
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                v-model="userData.first_name"
                label="Имя"
                type="email"
                outlined
                :rules="[required]" />
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-autocomplete
                v-model="userData.region"
                label="Выберите регион"
                :items="regions"
                item-text="name"
                item-value="code"
                outlined
                :rules="[required]"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                v-model.trim="userData.phone"
                label="Введите номер телефона"
                type="text"
                outlined
                :rules="[required]" />
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                v-model.trim="userData.email"
                label="Введите e-mail почту"
                type="email"
                outlined
                :rules="[required, emailRules]" />
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                v-model="userData.password"
                label="Введите пароль"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                :rules="[required, min4]"
                outlined
                @click:append="show2 = !show2">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                v-model="confirmPassword"
                label="Подтвердите пароль"
                :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                :rules="[required, min4, errorMessage]"
                outlined
                @click:append="show1 = !show1">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-btn
                class="primary"
                block
                type="submit"
                :disabled="
                  !userData.email ||
                  !userData.password ||
                  !userData.first_name ||
                  !userData.last_name ||
                  !userData.phone ||
                  !userData.region ||
                  !matchingPasswords ||
                  !matchingEmail
                ">
                Получить код
              </v-btn>
              <div
                class="d-flex align-center justify-space-between flex-wrap mt-4 mb-0">
                <a class="ms-2 mb-1" @click.prevent="$emit('cancel')">
                  Закрыть
                </a>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PreLoader from "../../components/preloader/PreLoader.vue";
import LogoImg from "../../components/Logo/Logo.vue";
export default {
  name: "RegisterUser",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PreLoader,
    LogoImg,
  },
  data: () => ({
    userData: {
      email: "",
      last_name: "",
      first_name: "",
      password: "",
      role: "user",
      region: "",
      phone: "",
    },
    isLoading: false,
    show1: true,
    show2: true,
    show3: true,
    confirmPassword: "",
    emailRules: (v) =>
      !v ||
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,34})+$/.test(v) ||
      "Введите действительный e-mail",
  }),
  computed: {
    ...mapGetters(["isLoggedIn", "user", "regions"]),
    matchingPasswords() {
      return this.userData.password === this.confirmPassword;
    },
    matchingEmail() {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,34})+$/.test(
        this.userData.email,
      );
    },
    errorMessage() {
      return this.matchingPasswords ? true : "Пароли не соответствуют";
    },
    isShow() {
      return this.isOpen;
    },
  },
  mounted() {
    this.getRegions();
  },
  methods: {
    ...mapActions(["registrationWithCode", "getRegions"]),
    async routeMain() {
      this.isLoading = true;
      this.userData.email = this.userData.email.toLocaleLowerCase().trim();
      const res = await this.registrationWithCode(this.userData);
      if (res && res.accessToken) {
        this.$toast.success("Вы успешно зарегистрировались");
      } else if (res.message) {
        this.$toast.error(res.message);
      }
      this.isLoading = false;
    },
    required(value) {
      if (value) {
        return true;
      } else {
        return "Обязательно!";
      }
    },
    min4(value) {
      if (value.length >= 4) {
        return true;
      } else {
        return "Пароль должен больше 4 символов!";
      }
    },
    routeToRestore(path) {
      this.$router.push({
        name: path,
      });
    },
  },
};
</script>

<style lang="scss"></style>
